import CountDown from './count-down.vue';
export default CountDown;


// WEBPACK FOOTER //
// ./src/components/count-down/index.js